<template>
  <div @click="gotoPart" class="item-container">
    <div class="img-container p-img-container">
      <img @load="calculateImg" alt="pic" v-if="getImg" :src="getImg" />
      <div v-if="getImg" class="enlarge-icon">
        <EnlargeIcon @click.stop="onImgClick" />
      </div>

      <div v-if="!getImg" class="no-img">{{ $t('common.no_img') }}</div>
    </div>

    <div class="item-info">
      <div
        style="margin-bottom: 5px"
        class="j-content part-name j-might-overflow"
      >
        {{ item.partName ? $t(item.partName) : '' }}
      </div>
      <div class="j-weak model-num j-might-overflow">
        <span> {{ $t('part_result.model_num') }} : </span>

        <span>{{ item.modelNum ? `${item.modelNum}` : '' }}</span>
      </div>
      <div class="j-weak model-num j-might-overflow">
        <span> {{ $t('part_result.vehicle_model_label') }} : </span>

        <span>{{ item.vehicleModel ? $t(item.vehicleModel) : '' }}</span>
      </div>
    </div>

    <PreviewImageModal
      @after-close="handleAfterClose"
      v-if="showPreviewModal"
      :images="previewImg"
    />

    <MultiStatusModal
      @after-close="handleAfterMultiStatusClose"
      v-if="showMultiStatusModal"
      :item="item"
      :type="1"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import EnlargeIcon from '@/components/icons/EnlargeIcon.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';
import { baseFileUrl } from '@/utils/constants';
import MultiStatusModal from '@/components/multi-status/MultiStatusModal.vue';

interface PartResultItemProps {
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'PartResultItem',
  components: {
    EnlargeIcon,
    PreviewImageModal,
    MultiStatusModal
  },
  data(): PartResultItemProps {
    return {
      baseFileUrl,
      showPreviewModal: false,
      previewImg: [],
      showMultiStatusModal: false
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    partName: {
      type: String,
      required: true,
      default: ''
    },
    modelNum: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    getImg() {
      let res = '';
      const partsImgs = this.item.partsImgs || [];

      if (partsImgs.length > 0) {
        if (partsImgs[0].fileUrl) {
          res = baseFileUrl + partsImgs[0].fileUrl;
        }
      }
      return res;
    }
  },
  created() {
    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.p-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    onImgClick() {
      this.previewImg.push(this.getImg);
      this.showPreviewModal = true;
    },
    handleAfterClose() {
      this.showPreviewModal = false;

      this.previewImg = [];
    },
    async handleAfterMultiStatusClose(data, isCancel) {
      this.showMultiStatusModal = false;
      if (isCancel) {
        return;
      }
      if (data) {
        this.$router.push(
          `/partdetail/${data.diagramId}?name=${this.partName}&modelNum=${this.modelNum}`
        );
      }
    },
    gotoPart() {
      if (this.item.differentStatus === 1) {
        this.showMultiStatusModal = true;
      } else {
        this.$router.push(
          `/part-detail/${this.item.id}/${this.item.vehicleId}/?name=${this.partName}&modelNum=${this.modelNum}`
        );
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.item-container {
  border-radius: 1px;
  border: 1px solid $secondary-color2;

  .item-info {
    background-color: $secondary-color1;
    padding: 14.5px 20px;
    .model-num {
      color: #999999;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .part-name {
      font-weight: bold;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  &:hover {
    border: 1px solid $primary-color;
    transition: border 0.5s;

    .item-info {
      transition: all 0.5s;
      background-color: $primary-color;
      .part-name,
      .model-num {
        color: white;
      }
    }
  }

  .img-container {
    cursor: pointer;
    position: relative;

    .enlarge-icon {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    img {
      display: inline-block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .no-img {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
